import styles from '../SpendingLimitCard.module.css';
import { FormattedCurrency } from '../../../../../iwIntlProvider/FormattedCurrency';
import { tracking } from '@iwoca/frontend-tracking-library';
import { Pill, Tooltip } from '@iwoca/orion';
import refreshIconSvg from './refreshIcon.svg';
import refreshIconGreySvg from './refreshIconGrey.svg';
import classNames from 'classnames';
import { GetBuyerSpendingLimitResponse } from '@iwoca/lapi-client/iwocapay';

export const ExpiredLimits = ({
    setIsSpendingLimitDrawerOpen,
    spendingLimit,
    loading,
    handleClick
}: {
    setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
    spendingLimit: GetBuyerSpendingLimitResponse['data']['active_spending_limit'];
    loading: boolean;
    handleClick: () => void;
}) => {
    return (
        <>
            <div className={styles.leftInnerContainer}>
                <div className={styles.remainingLimitHeader}>
                    <div>
                        You have{' '}
                        <FormattedCurrency
                            className={styles.remainingLimitAmount}
                            value={spendingLimit.available_amount}
                        />{' '}
                        left to spend
                    </div>
                    <Pill className={styles.estimatedPill}>Estimated</Pill>
                </div>
                <div className={styles.interestRateLabel}>
                    This is an estimated amount based on your last transaction
                    with us - refresh it by clicking “Secure my limit” or make a
                    purchase with Pay Later.
                </div>
            </div>
            <div className={styles.rightInnerContainer}>
                <div className={styles.spendingLimitAmount}>
                    <div>
                        Estimated spending limit:{' '}
                        <FormattedCurrency value={spendingLimit.max_amount} />
                    </div>
                    <button
                        className={classNames(styles.secureLimitButton, {
                            [styles.secureLimitButtonDisabled]: loading
                        })}
                        onClick={() => handleClick()}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <img
                                    src={refreshIconGreySvg}
                                    className={styles.spinningIcon}
                                    alt=""
                                />
                                Checking limit...
                            </>
                        ) : (
                            <Tooltip
                                content="Subject to approval and reassessed every 30 days - if something changes with your business the amounts might change."
                                placement="top"
                                variant="primary"
                                className={styles.secureLimitButtonTooltip}
                            >
                                <div className={styles.secureLimitButton}>
                                    <img src={refreshIconSvg} alt="" />
                                    Secure my limit
                                </div>
                            </Tooltip>
                        )}
                    </button>
                </div>
                <div className={styles.spendingLimitDurationLabel}>
                    {spendingLimit.duration_in_months} month purchases{' '}
                    <button
                        onClick={() => {
                            tracking.ampli.spendingLimitViewedOtherTerms();
                            setIsSpendingLimitDrawerOpen(true);
                        }}
                        className={styles.otherTermsButton}
                    >
                        Other terms
                    </button>
                </div>
            </div>
        </>
    );
};
